import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/success.png'
import _imports_1 from '../assets/kf.png'


const _withScopeId = n => (_pushScopeId("data-v-28d868db"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nonbid_success" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "success" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ok" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "保函申请已提交成功！"),
  /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
    /*#__PURE__*/_createTextVNode(" 稍后会有专属客户经理与您联系并确认订单，"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 请保持手机畅通。 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "kf" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
  ])
], -1))
const _hoisted_3 = { class: "model" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "出函进度", -1))
const _hoisted_5 = { class: "steps" }
const _hoisted_6 = { class: "make" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "a" }, "保函申请", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "b" }, "保函申请提交成功", -1))
const _hoisted_9 = { class: "t" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step" }, "订单确认", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step" }, "风控审批", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step" }, "保费支付", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step" }, "签署协议", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step" }, "成功出函", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_step = _resolveComponent("van-step")!
  const _component_van_steps = _resolveComponent("van-steps")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_van_steps, {
          direction: "vertical",
          active: 0
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.timenow), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }),
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }),
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}